(() => {
  function isPreview() {
    return Boolean(window.Shopify?.designMode || document.querySelector('#PBarNextFrame') || new URLSearchParams(location.search).has('preview_theme_id'));
  }
  function track(section, eventName, detail = {}) {
    if (isPreview() || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return false;
    const destination = section.dataset.ga4;
    if (!/^G-[A-Z0-9]+$/.test(destination || '') || typeof window.gtag !== 'function') return false;
    window.gtag('event', eventName, { send_to: destination, offer_campaign: section.dataset.campaign, offer_placement: 'homepage_featured_offer', ...detail });
    return true;
  }
  function initialise(root = document) {
    root.querySelectorAll('.cc-offer:not([data-offer-ready]), .cc-launch[data-inline-buy]:not([data-offer-ready])').forEach(section => {
      section.dataset.offerReady = 'true';
      const more = section.querySelector('[data-mobile-collapse]');
      if (more) {
        const mobile = matchMedia('(max-width: 749px)');
        const toggle = more.querySelector('.cc-offer__toggle');
        const extras = more.querySelector('.cc-offer__extras');
        const setExpanded = expanded => { extras.hidden = !expanded; toggle.setAttribute('aria-expanded', String(expanded)); toggle.querySelector('span').textContent = expanded ? '−' : '+'; };
        setExpanded(!mobile.matches);
        toggle.addEventListener('click', () => setExpanded(extras.hidden));
        const resizeOffers = () => setExpanded(!mobile.matches);
        mobile.addEventListener('change', resizeOffers);
        section.addEventListener('cc-offer-cleanup', () => mobile.removeEventListener('change', resizeOffers), { once: true });
      }
      let visible = false;
      let viewRecorded = false;
      const recordView = () => {
        if (visible && !viewRecorded) viewRecorded = track(section, 'cc_offer_view');
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.25);
          recordView();
        }, { threshold: 0.25 });
        observer.observe(section);
        document.addEventListener('visitorConsentCollected', recordView);
        section.addEventListener('cc-offer-cleanup', () => {
          observer.disconnect();
          document.removeEventListener('visitorConsentCollected', recordView);
        }, { once: true });
      }
      section.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (link) track(section, 'cc_offer_click', { offer_slot: link.dataset.slot || 'collection' });
      });
      section.querySelectorAll('[data-cc-offer-form]').forEach(form => {
        const quantity = form.querySelector('[name="quantity"]');
        const submit = form.querySelector('[type="submit"]');
        const status = form.querySelector('.cc-offer__status');
        const selector = form.querySelector('select[name="id"]');
        form.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
          const step = Number(quantity.step) || 1;
          const min = Number(quantity.min) || 1;
          const max = quantity.max ? Number(quantity.max) : Infinity;
          quantity.value = Math.min(max, Math.max(min, (Number(quantity.value) || min) + Number(button.dataset.quantityChange) * step));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }));
        if (selector) selector.addEventListener('change', () => {
          const option = selector.selectedOptions[0];
          const card = form.closest('[data-offer-card]');
          const price = card.querySelector('.cc-offer__price > span');
          const compare = card.querySelector('.cc-offer__price s');
          price.textContent = option.dataset.price;
          if (compare) {
            compare.textContent = option.dataset.compare;
            compare.hidden = !option.dataset.compare;
          }
          const badge = card.querySelector('.cc-offer__saving');
          if (badge) badge.hidden = true;
          const image = card.querySelector('img');
          if (image && option.dataset.image && card.dataset.fixedImage !== 'true') {
            image.src = option.dataset.image;
            image.removeAttribute('srcset');
            image.alt = `${form.dataset.productName} - ${option.textContent.trim()}`;
          }
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.step || '1';
          quantity.max = option.dataset.max || '';
          quantity.value = quantity.min;
          card.querySelectorAll('a[data-product-link]').forEach(link => {
            const url = new URL(link.href);
            url.searchParams.set('variant', option.value);
            link.href = url.toString();
          });
          status.textContent = '';
        });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (submit.disabled || !form.reportValidity()) return;
          const originalLabel = submit.textContent;
          submit.disabled = true;
          ccSetBasketBusy(submit, true);
          status.textContent = '';
          const data = new FormData(form);
          const cart = document.querySelector('mini-cart');
          if (cart?.getSectionsToRender) {
            data.append('sections', cart.getSectionsToRender().map(item => item.id).join(','));
            data.append('sections_url', location.pathname);
            cart.setActiveElement?.(submit);
          }
          let added = false;
          try {
            const response = await fetch(form.action.replace(/\/add$/, '/add.js'), { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || form.dataset.error);
            added = true;
            ccShowCartConfirmation(status, result, form.closest('[data-offer-card]')?.querySelector('h3')?.textContent.trim() || form.dataset.productName);
            status.dataset.confirmedCampaign = result.properties?._cc_offer_campaign || '';
            status.dataset.confirmedSource = result.properties?._cc_offer_source || '';
            status.dataset.confirmedQuantity = String(data.get('quantity'));
            const detail = { offer_slot: form.dataset.slot, product_id: form.dataset.productId, variant_id: String(data.get('id')), items_added: Number(data.get('quantity')), currency: section.dataset.currency, value: (result.price / 100) * Number(data.get('quantity')) };
            track(section, 'cc_offer_add_to_cart', detail);
            section.dispatchEvent(new CustomEvent('cc:offer-added', { bubbles: true, detail }));
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cc-featured-offer', productVariantId: data.get('id'), cart: result });
            if (cart?.renderContents) {
              cart.renderContents(result);
              cart.classList.remove('is-empty');
            } else location.assign(section.dataset.cartUrl);
          } catch (error) {
            if (!added) status.textContent = error.message || form.dataset.error;
          } finally {
            submit.disabled = false;
            ccSetBasketBusy(submit, false);
            submit.textContent = originalLabel;
          }
        });
      });
    });
  }
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => initialise());
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.cc-offer').forEach(section => section.dispatchEvent(new Event('cc-offer-cleanup'))));
})();
